import { useQuery } from '@tanstack/react-query';
import { getParkingService } from '../../api/parking-service.ts';
import { normalizeNulls } from '../../utils/normalizeNulls.ts';

export default function useParkingService(
  serviceId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['parkingServices', serviceId],
    queryFn: async () => {
      return await getParkingService(serviceId);
    },
    select: normalizeNulls,
    enabled: !!serviceId && (options?.enabled ?? true),
  });
}
